// import React from 'react';
// import classes from '../HospitalList/HospitalList.module.scss';

// const Hospital = ({ hospitalList }) => {
//   return (
//     <div>
//       <h2>List Of Hospitals</h2>
//       {hospitalList.length > 0 ? (
//         <table className={classes.Table}>
//           <thead>
//             <tr>
//               <th>Name</th>
//               <th>Category</th>
//             </tr>
//           </thead>
//           <tbody>
//             {hospitalList.map((item, index) => (
//               <tr key={index}>
//                 <td>{item.hsptl_name}</td>
//                 <td>{item.cata}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       ) : (
//         <p>No hospitals available.</p>
//       )}
//     </div>
//   );
// };

// export default Hospital;



//////////////////////////////////Testing Code which on click on the hospitals names and show the details:::::::::
// import React from 'react';
// import classes from '../HospitalList/HospitalList.module.scss';
// import HospitalItem from './HospitalItem';

// const Hospital = ({ hospitalList, onHospitalClick }) => {
//   return (
//     <div>
//       <h2>List Of Hospitals</h2>
//       {hospitalList.length > 0 ? (
//         <table className={classes.Table}>
//           <thead>
//             <tr>
//               <th>Name</th>
//               <th>Category</th>
//             </tr>
//           </thead>
//           <tbody>
//             {hospitalList.map((item, index) => (
//               <HospitalItem key={index} item={item} index={index} onClick={onHospitalClick} />
//             ))}
//           </tbody>
//         </table>
//       ) : (
//         <p>No hospitals available.</p>
//       )}
//     </div>
//   );
// };

// export default Hospital;


////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////This code look like into the card format of the Hospitals Details::::::::::::::::
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

import React from 'react';
import classes from '../HospitalList/HospitalList.module.scss';
import HospitalDetails from './HospitalDetails';

const Hospital = ({ hospitalList, selectedHospitalDetails, onHospitalClick }) => {
  return (
    <div>
      <h2>List Of Hospitals</h2>
      {hospitalList.length > 0 ? (
        <table className={classes.Table}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Category</th>
            </tr>
          </thead>
          <tbody>
            {hospitalList.map((item, index) => (
              <React.Fragment key={index}>
                <tr
                  className={classes.ClickableRow}
                  onClick={() => onHospitalClick(item.hsptl_name)}
                >
                  <td>{item.hsptl_name}</td>
                  <td>{item.category || 'Hospital'}</td>
                </tr>
                {selectedHospitalDetails?.hsptl_name === item.hsptl_name && (
                  <tr>
                    <td colSpan="2">
                      <div className={classes.HospitalDetailsSection}>
                      <HospitalDetails details={selectedHospitalDetails} />
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No hospitals available.</p>
      )}
    </div>
  );
};

export default Hospital;

